import {deliveryApi} from "@/axios";

export function weiChatCon(){
    return deliveryApi({
        method:'get',
        url:'/wechat/articleList',
    })
}
